import CobraSpinner from './CobraSpinner';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box,  Center } from '@chakra-ui/react';
import ReactPlayer from 'react-player';
import axiosInstance from '../services/axiosInstance';

const VideoPlayer = ({ src, video, style }) => {
  const rawUrl = src || (video && video.url);
  const baseUrl = axiosInstance.defaults.baseURL.replace('/api', '');
  
  let videoUrl = rawUrl;
  if (rawUrl) {
    if (rawUrl.startsWith('/uploads')) {
      videoUrl = `${baseUrl}${rawUrl}`;
    } else if (rawUrl.startsWith('uploads/')) {
      videoUrl = `${baseUrl}/${rawUrl}`;
    }
  }
  
  console.log("Matiere Video URL:", videoUrl, "Raw URL:", rawUrl, "Video object:", video);
  const [isReady, setIsReady] = useState(false);

  return (
    <Box 
      width="100%" 
      height={style?.height || 450} 
      mx="auto" 
      dir="rtl"
      onContextMenu={(e) => e.preventDefault()}
      position="relative"
      borderRadius="xl"
      overflow="hidden"
      boxShadow="2xl"
      bg="black"
      transition="all 0.3s ease-in-out"
      _hover={{ boxShadow: '3xl' }}
      border="1px solid rgba(255, 255, 255, 0.1)"
      style={style}
    >
      {videoUrl ? (
        <>
          {!isReady && (
            <Center position="absolute" top="0" left="0" w="100%" h="100%" bg="gray.900" zIndex={1}>
              <CobraSpinner size="xl" color="blue.400" thickness="4px" />
            </Center>
          )}
          <ReactPlayer
            url={videoUrl}
            controls
            width="100%"
            height="100%"
            onReady={() => setIsReady(true)}
            config={{
              file: {
                attributes: {
                  controlsList: 'nodownload'
                }
              }
            }}
            style={{ position: 'absolute', top: 0, left: 0 }}
          />
        </>
      ) : (
        <Center height="100%" bg="gray.800" color="white" fontSize="lg" fontWeight="semibold">
          لا يوجد رابط للفيديو
        </Center>
      )}
    </Box>
  );
};

VideoPlayer.propTypes = {
  src: PropTypes.string,
  video: PropTypes.object,
  style: PropTypes.object
};

export default VideoPlayer;
